import { render } from "./TableFooter.vue?vue&type=template&id=2166f296&scoped=true"
import script from "./TableFooter.vue?vue&type=script&lang=ts"
export * from "./TableFooter.vue?vue&type=script&lang=ts"

import "./TableFooter.vue?vue&type=style&index=0&id=2166f296&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2166f296"

export default script